import { createFileRoute } from "@tanstack/react-router";
import { filterParam, optionParam, textParam } from "@/utils/searchParams";
import type { UserStatus } from "@/hooks/types";

// The directory's filters live in the URL, so leaving the page and coming back
// keeps the slice of people the admin had narrowed to (NAV-45).
export const USER_STATUSES = [
  "ACTIVE",
  "PENDING",
  "INACTIVE",
] as const satisfies readonly UserStatus[];

export type BuUsersSearch = {
  q?: string;
  status?: UserStatus;
  /** A house inside the unit (ADR 0025), or `unit` for the unit itself. Data
   *  rather than a fixed list: the options are whichever houses the unit's
   *  people are actually in, and one that no longer exists filters to nothing,
   *  which is what the page says too. */
  house?: string;
};

export const Route = createFileRoute("/bu-admin/users")({
  validateSearch: (search: Record<string, unknown>): BuUsersSearch => ({
    q: textParam(search.q),
    status: optionParam(USER_STATUSES, search.status),
    house: filterParam(search.house),
  }),
});
